module.exports = __webpack_public_path__ + "img/green_review.c17ad97c.svg";